<template>
    <div>
        <div class="skeleton-wrapper-long">
            <skeleton-loader class="shortcut-loading-full"/>
        </div>
        <div class="skeleton-wrapper-medium">
            <skeleton-loader class="shortcut-loading-full"/>
        </div>
        <div class="skeleton-wrapper-short">
            <skeleton-loader class="shortcut-loading-full"/>
        </div>
    </div>

</template>

<script setup lang="ts">
import { SkeletonLoader } from '@bookingkit/coppi';
</script>

<style scoped>.skeleton-wrapper-long,
.skeleton-wrapper-medium,
.skeleton-wrapper-short {
  overflow: hidden;
  border-radius: var(--s3);
  margin-top: var(--s6);
}

.skeleton-wrapper-long {
  width: 66.666%;
}

.skeleton-wrapper-medium {
  width: 80%;
}

.skeleton-wrapper-short {
  width: 45%;
}

.shortcut-loading-full {
  width: 500px;
}

</style>
